export const ActivityAgentPermissions = {
  ActivityAgentPermissions: {
    permissionsId: "8f4c6ea7-fb17-4f0a-7978-08dcaf947ea8",
    permissionsName: "Activity Agents",
    description: null,
    componentsId: null,
    components: null,
  },
};
